var _path, _path2, _rect, _g, _rect2, _rect3, _g2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 404,
    height: 247,
    viewBox: "0 0 404 247",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.85742 16.7832C3.85742 9.68953 9.88092 3.93896 17.3113 3.93896H386.62C394.05 3.93896 400.073 9.68953 400.073 16.7832V229.998C400.073 237.091 394.05 242.842 386.62 242.842H17.3113C9.88092 242.842 3.85742 237.091 3.85742 229.998V16.7832Z",
    fill: "#FFEEE9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3113 13.1726H386.62C388.816 13.1726 390.474 14.8551 390.474 16.7832V229.998C390.474 231.926 388.816 233.608 386.62 233.608H17.3113C15.115 233.608 13.4568 231.926 13.4568 229.998V16.7832C13.4568 14.8551 15.115 13.1726 17.3113 13.1726ZM17.3113 2.41187C9.10503 2.41187 2.33033 8.78018 2.33033 16.7832V229.998C2.33033 238.001 9.10504 244.369 17.3113 244.369H386.62C394.826 244.369 401.6 238.001 401.6 229.998V16.7832C401.6 8.78018 394.826 2.41187 386.62 2.41187H17.3113Z",
    fill: "white",
    stroke: "#FFEEE9",
    strokeWidth: 3.05418
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 332.131,
    y: 19.9937,
    width: 48.4339,
    height: 17.9819,
    rx: 3.1883,
    fill: "#802A13"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3173_30075)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.3672,
    y: 19.9937,
    width: 48.4339,
    height: 17.9819,
    fill: "#802A13"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 19.9937,
    width: 14.7992,
    height: 17.9819,
    fill: "#FF5326"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.5098,
    y: 19.9937,
    width: 17.49,
    height: 17.9819,
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 89.2891,
    y: 19.9937,
    width: 214.589,
    height: 17.9819,
    rx: 3.1883,
    fill: "#FFA993"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 89.2891,
    y: 41.187,
    width: 214.589,
    height: 6.42212,
    rx: 3.1883,
    fill: "#FFA993"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 159.756,
    y: 125.094,
    width: 125.141,
    height: 15.9415,
    rx: 3.1883,
    fill: "#FFA993"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 158.959,
    y: 145.818,
    width: 125.141,
    height: 15.1444,
    rx: 3.1883,
    fill: "#FFA993"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 159.756,
    y: 165.745,
    width: 124.344,
    height: 15.9415,
    rx: 3.1883,
    fill: "#FFA993"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 159.756,
    y: 186.469,
    width: 124.344,
    height: 15.1444,
    rx: 3.1883,
    fill: "#FFA993"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 294.463,
    y: 186.537,
    width: 78.705,
    height: 15.4131,
    rx: 3.1883,
    fill: "#FFA993"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 159.756,
    y: 64.5166,
    width: 74.9251,
    height: 15.1444,
    rx: 3.1883,
    fill: "#FFA993"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 158.959,
    y: 96.3994,
    width: 125.141,
    height: 15.9415,
    rx: 3.1883,
    fill: "#FFA993"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 294.859,
    y: 208.423,
    width: 68.6146,
    height: 8.99097,
    rx: 3.1883,
    fill: "#FFA993"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.633 136.652C138.633 168.567 112.76 194.44 80.8446 194.44C48.9292 194.44 23.0566 168.567 23.0566 136.652C23.0566 104.736 48.9292 78.8638 80.8446 78.8638C112.76 78.8638 138.633 104.736 138.633 136.652ZM56.4449 119.315L65.7021 110.647L83.0246 129.215L101.392 112.209L110.002 121.52L91.6341 138.444L108.454 156.474L99.7859 165.546L82.3755 146.975L63.9119 163.987L54.8936 155.263L73.7645 137.79L56.4449 119.315Z",
    fill: "#FF5326"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3173_30075"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.3672,
    y: 19.9937,
    width: 48.434,
    height: 17.9819,
    rx: 3.1883,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentError);
export default __webpack_public_path__ + "static/media/document_error.390fcfe4992745c42b7327449f93c147.svg";
export { ForwardRef as ReactComponent };